var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.5C20.5 4.97715 16.0229 0.5 10.5 0.5C4.97715 0.5 0.5 4.97715 0.5 10.5C0.5 15.4912 4.15684 19.6283 8.9375 20.3785V13.3906H6.39844V10.5H8.9375V8.29688C8.9375 5.79063 10.4305 4.40625 12.7146 4.40625C13.8084 4.40625 14.9531 4.60156 14.9531 4.60156V7.0625H13.6922C12.45 7.0625 12.0625 7.8334 12.0625 8.625V10.5H14.8359L14.3926 13.3906H12.0625V20.3785C16.8432 19.6283 20.5 15.4912 20.5 10.5Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFinal);
export default __webpack_public_path__ + "static/media/facebook-final.c4ee262051beb1bee039d3e333b34201.svg";
export { ForwardRef as ReactComponent };